export default "__VITE_ASSET__CqXyTYS3__"